import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'templateFieldTranslate',
  standalone: true,
  pure: false
})
export class TemplateFieldTranslatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(obj: any, fieldPrefix: 'label' | 'descr' | 'blockName' | 'values' | 'name'): string {
    if (!obj) return '';

    const currentLang = this.translateService.currentLang || 'en';

    // Map language codes
    const langMap: { [key: string]: string } = {
      'en': 'en',
      'en-US': 'en',
      'ru': 'ru',
      'ru-RU': 'ru',
      'uz': 'uz',
      'uz-Latn-UZ': 'uz'
    };

    const lang = langMap[currentLang] || 'en';
    const fieldName = `${fieldPrefix}_${lang}`;

    return obj[fieldName] || obj[`${fieldPrefix}_en`] || '';
  }
}
